import React from 'react'
import AdminLogin from '../../Components/Admin/Login/Login'

function Login() {
    return (
        <div>
            <AdminLogin />
        </div>
    )
}

export default Login
